/**
 * cart-bubble-instant.js — optimistic header cart-count for hkskincart-2 (Horizon).
 *
 * Why: stock Horizon only updates the header cart bubble AFTER two sequential
 * round trips (POST /cart/add with header-section rendering ~1.5-2.3s, then
 * GET /cart.js ~0.2s), so on mobile the count lags ~2s behind the tap.
 * This file bumps the bubble the instant a valid add-to-cart form submits,
 * then reconciles to the server total when the theme's own cart:update lands.
 *
 * Additive custom file — no stock file logic is modified. Loaded from
 * snippets/scripts.liquid. Rollback = delete this asset + remove its <script>
 * line from snippets/scripts.liquid.
 *
 * End state is always identical to stock: the capture-phase cart:update
 * listener pre-sets the visible count so cart-icon's own "+= itemCount"
 * lands exactly on the server's item_count.
 */
(function () {
  'use strict';
  if (window.__cartBubbleInstant) return;
  window.__cartBubbleInstant = true;

  var pending = 0;
  var recoverTimer = null;

  function icons() {
    return Array.prototype.slice.call(document.querySelectorAll('cart-icon'));
  }

  function bump(qty) {
    icons().forEach(function (icon) {
      if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(qty, true);
    });
    pending += qty;
    // Safety net: if the add request dies and no cart:update ever arrives,
    // re-sync the bubble from the server so it never stays optimistically wrong.
    clearTimeout(recoverTimer);
    recoverTimer = setTimeout(function () {
      if (pending <= 0) return;
      pending = 0;
      var cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) ? Theme.routes.cart_url : '/cart';
      fetch(cartUrl + '.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          icons().forEach(function (icon) {
            if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count, false, false);
          });
        })
        .catch(function () {});
    }, 12000);
  }

  // Every add path (PDP button, sticky bar puppet click, quick-add modal)
  // funnels exactly once through a product-form-component form submit.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var pf = form.closest('product-form-component');
    if (!pf) return;
    try {
      // Mirror the theme's own pre-flight max-quantity check so a rejected
      // add (error message, no network call) is never counted.
      var qs = pf.refs && pf.refs.quantitySelector;
      if (qs && typeof qs.canAddToCart === 'function' && !qs.canAddToCart().canAdd) return;
      var qty = (qs && typeof qs.getValue === 'function' && Number(qs.getValue())) || Number(pf.dataset.quantityDefault) || 1;
      bump(qty);
    } catch (e) { /* never interfere with the real add */ }
  }, true);

  // Capture phase runs before cart-icon's bubbling document listener.
  document.addEventListener('cart:update', function (event) {
    if (pending <= 0) return;
    var detail = event.detail || {};
    var data = detail.data || {};
    if (data.source !== 'product-form-component') { pending = 0; return; }
    var added = Number(data.itemCount) || 0;
    var real = (detail.resource && typeof detail.resource.item_count === 'number') ? detail.resource.item_count : null;
    document.querySelectorAll('cart-icon [ref="cartBubbleCount"]').forEach(function (el) {
      var current = parseInt(el.textContent || '0', 10) || 0;
      // With the server total: land on it exactly. Without (error path):
      // back out our own bump so stock's "+= itemCount" reproduces stock's result.
      el.textContent = String(Math.max(0, (real !== null ? real : current) - added));
    });
    pending = Math.max(0, pending - added);
    if (pending === 0) clearTimeout(recoverTimer);
  }, true);

  // v2: cart refreshes now morph only the drawer's inner section
  // (#shopify-section-header-cart-items), so the dialog element around it no
  // longer gets its empty-state class updated by the theme — sync it here.
  document.addEventListener('cart:update', function (event) {
    var detail = event.detail || {};
    var data = detail.data || {};
    var count = null;
    if (detail.resource && typeof detail.resource.item_count === 'number') {
      count = detail.resource.item_count;
    } else if (typeof data.itemCount === 'number' && data.source !== 'product-form-component') {
      count = data.itemCount;
    }
    if (count === null) return;
    document.querySelectorAll('.cart-drawer__dialog').forEach(function (dialog) {
      dialog.classList.toggle('cart-drawer--empty', count === 0);
      dialog.setAttribute('aria-labelledby', count === 0 ? 'cart-drawer-heading-empty' : 'cart-drawer-heading');
    });
  });
})();
